import type { SelectedPositionPrice } from 'types/SelectedPositionPrice';
import { applyTaxRate, formatPrice } from 'utils/price';

export const createSelectedPositionPrice = ({
  menuNetPrice,
  taxRate,
}: {
  menuNetPrice: number;
  taxRate: number;
}): SelectedPositionPrice => ({
  menuNetPrice,
  netPrice: formatPrice(menuNetPrice),
  grossPrice: formatPrice(applyTaxRate(menuNetPrice, taxRate)),
  isGrossEdited: false,
  isEdited: false,
});
